<template>
  <v-menu
    v-if="menuActive"
    ref="attachments-menu"
    v-model="menuActive"
    offset-x
    :open-on-click="true"
    :close-on-click="true"
    :close-on-content-click="false"
    :nudge-left="150"
    :nudge-top="50"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        small
        :color="attachmentColor"
        v-on="on"
      >
        description
      </v-icon>
    </template>
    <v-card class="pa-2">
      <Attachments
        :value="dataForExport"
        :resource="`shippings/${shippingId}`"
        :type="attachmentsType.EXPORT"
        :disabled="!canEdit"
        :disabled-sender="!user.hasEmployee"
        :disabled-upload="!user.hasEmployee"
        :disabled-upload-to-server="!user.hasEmployee"
        :disabled-download="!user.hasEmployee"
        title="Экспортные документы"
        @input="update"
        @change="update"
      />
      <v-divider class="mt-2" />
      <Attachments
        :value="data"
        :resource="`shippings/${shippingId}`"
        :disabled="!canEdit"
        :disabled-sender="!user.hasEmployee"
        :disabled-upload="!user.hasEmployee"
        :disabled-upload-to-server="!user.hasEmployee"
        :disabled-download="!user.hasEmployee"
        title="Другие документы"
        @input="update"
        @change="update"
      />
    </v-card>
  </v-menu>
  <v-icon
    v-else
    small
    :color="attachmentColor"
    @click="menuActive = true"
  >
    description
  </v-icon>
</template>
<script>
import { attachmentsType } from "../../../enums/attachments-types.js";
import { eShippingStates } from "../../shippings/shipping-states.js";
import Attachments from "../../../components/attachments/Attachments.vue";

export default {
  components: {
    Attachments,
  },
  props: ["data", "dataForExport", "user", "shippingId", "shippingState"],
  data() {
    return {
      menuActive: false,
      attachments: [],
      attachmentsForExport: [],
    };
  },
  computed: {
    canEdit() {
      return (
        this.shippingState !== eShippingStates.NotAccepted &&
        this.shippingState !== eShippingStates.CanceledByClient
      );
    },
    attachmentsType() {
      return attachmentsType;
    },
    attachmentColor() {
      return this.data.length > 0 || this.dataForExport.length > 0
        ? "green"
        : "grey";
    },
  },
  watch: {
    data: {
      handler(val) {
        this.attachments = val.map(a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        });
      },
    },
    dataForExport: {
      handler(val) {
        this.attachmentsForExport = val.map(a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        });
      },
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.menuActive;
      },
      newVal => {
        if (newVal) {
          this.$refs["attachments-menu"].isActive = true;
        }
      },
    );
  },
  methods: {
    update() {
      this.$emit("update");
    },
  },
};
</script>
